const {REACT_APP_PORTFOLIO_TYPE} = process.env;
const pathname = window.location.pathname;
const type = !!REACT_APP_PORTFOLIO_TYPE ? REACT_APP_PORTFOLIO_TYPE : pathname.split('/')[1];

export default {
  type
}



// WEBPACK FOOTER //
// ./src/config.js